module.exports = __webpack_public_path__ + "static/media/rtu.9743bb24.png";